import React from 'react';

const Label = ({ label, asterisk, id, customClass = '' }) => {
  return (
    <div className={`custom-field-label ${customClass}`} id={id}>
      {label}
      {asterisk && label && <span className="color-asterisk">{' *'}</span>}
    </div>
  );
};

export default Label;
